import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { authFB } from '../../helpers/Firebase';
import { servicePath } from '../../constants/defaultValues';
import { NotificationManager } from '../../components/common/react-notifications';
import { 
  REVIEW_DETAIL,
  REVIEW_SEARCH,
  REVIEW_ADD,
  REVIEW_SEARCH_REVIEW_STATE_LIST,
  REVIEW_SEARCH_SUPPLIER_LIST,
  REVIEW_LIST,
  REVIEW_UPDATE,
} from '../actions';

import {
  ReviewDetailSuccess,
  ReviewDetailError,
  ReviewSearchSuccess,
  ReviewSearchError,
  ReviewAddSuccess,
  ReviewAddError,
  ReviewSearchReviewStateListSuccess,
  ReviewSearchReviewStateListError,
  ReviewSearchSupplierListSuccess,
  ReviewSearchSupplierListError,
  ReviewListSuccess,
  ReviewListError,
  ReviewUpdateSuccess,
  ReviewUpdateError,
} from '../actions';

export function* watchReviewDetail() {
  yield takeEvery(REVIEW_DETAIL, onReviewDetail);
}

export function* watchReviewSearch() {
  yield takeEvery(REVIEW_SEARCH, onReviewSearch);
}

export function* watchReviewAdd() {
  yield takeEvery(REVIEW_ADD, onReviewAdd);
}

export function* watchReviewSearchReviewStateList() {
  yield takeEvery(REVIEW_SEARCH_REVIEW_STATE_LIST, onReviewSearchReviewStateList);
}

export function* watchReviewSearchSupplierList() {
  yield takeEvery(REVIEW_SEARCH_SUPPLIER_LIST, onReviewSearchSupplierList);
}

export function* watchReviewList() {
  yield takeEvery(REVIEW_LIST, onReviewList);
}

export function* watchReviewUpdate() {
  yield takeEvery(REVIEW_UPDATE, onReviewUpdate);
}

function getToken(auth) {
  return new Promise((resolve, reject) => {
    const unsubscribe = auth.onAuthStateChanged(user => {
      user.getIdToken().then((token) => {
        unsubscribe();
        resolve(token);
      });
    }, reject);
  });
}

const onReviewDetailAsync  = async (data) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'review/get', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(data.payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return { "data": response };
};

const onReviewSearchAsync = async (data) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'review/search', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(data)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return { message: true, data: response };
};

const onReviewAddAsync = async (data) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'review/add', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(data)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return { message: true, data: response };
};

const onReviewSearchReviewStateListAsync = async () => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/review_state', {
    method: 'GET', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token }
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return response ;
};

const onReviewSearchSupplierListAsync = async () => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/supplier', {
    method: 'GET', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token }
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return response ;
};

const onReviewListAsync  = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'review/list', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return { "data": response };
};

const onReviewUpdateAsync = async (data) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'review/update', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(data)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return { message: true, data: response };
};

function* onReviewSearch(data) {
  try {
    const response = yield call(onReviewSearchAsync, data.payload);
    if (response.data.status === true) {
      NotificationManager.success(response.data.message, 'Exito', 3000, null, null, '');
    } else if (response.data.status === 'error') {
      NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
    }
    yield put(ReviewSearchSuccess(response.data.data));
  } catch (error) {
    console.log('catch error', error)
    yield put(ReviewSearchError(error));
  }
}

function* onReviewAdd(data) {
  try {
    const response = yield call(onReviewAddAsync, data.payload);
    if (response.data.status === true) {
      NotificationManager.success(response.data.message, 'Exito', 3000, null, null, '');
    } else if (response.data.status === 'error') {
      NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
    }
    yield put(ReviewAddSuccess(response.data.data));
  } catch (error) {
    console.log('catch error', error)
    yield put(ReviewAddError(error));
  }
}

function* onReviewDetail(data) {
  try {
    const response = yield call(onReviewDetailAsync, data);
    yield put(ReviewDetailSuccess(response.data.data));
  } catch (error) {
    yield put(ReviewDetailError(error));
  }
}

function* onReviewSearchReviewStateList(data) {
  try {
    const response = yield call(onReviewSearchReviewStateListAsync, data);
    yield put(ReviewSearchReviewStateListSuccess(response.data));
  } catch (error) {
    yield put(ReviewSearchReviewStateListError(error));
  }
}

function* onReviewSearchSupplierList(data) {
  try {
    const response = yield call(onReviewSearchSupplierListAsync, data);
    yield put(ReviewSearchSupplierListSuccess(response.data));
  } catch (error) {
    yield put(ReviewSearchSupplierListError(error));
  }
}

function* onReviewList(data) {
  try {
    const response = yield call(onReviewListAsync, data.payload);
    yield put(ReviewListSuccess(response.data));
  } catch (error) {
    yield put(ReviewListError(error));
  }
}

function* onReviewUpdate(data) {
  try {
    const response = yield call(onReviewUpdateAsync, data.payload);
    if (response.data.status === true) {
      NotificationManager.success(response.data.message, 'Exito', 3000, null, null, '');
    } else if (response.data.status === 'error') {
      NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
    }
    yield put(ReviewUpdateSuccess(response.data));
  } catch (error) {
    yield put(ReviewUpdateError(error));
  }
}

export default function* rootSaga() {
  yield all([
    fork(watchReviewDetail),
    fork(watchReviewSearch),
    fork(watchReviewSearchReviewStateList),
    fork(watchReviewSearchSupplierList),
    fork(watchReviewList),
    fork(watchReviewAdd),
    fork(watchReviewUpdate),
  ]);
}